window.initMap = () => {

	var map                 = false,
        sv                  = false,
        mapCanvas           = document.getElementById("map-canvas"),
        streetviewCanvas    = document.getElementById("streetview-canvas"),
        bounds              = (typeof(google) != 'undefined' ? new google.maps.LatLngBounds() : false),
        markers             = ($('.js-json-map-results').length > 0 ? JSON.parse($('.js-json-map-results').html()) : {}),
        mapMarkers          = [];

	if (typeof(mapCanvas) != 'undefined' && mapCanvas != null) {

		// Create the map
        map = new google.maps.Map(mapCanvas, {
            zoom              : 14,
            center            : new google.maps.LatLng(0,0),
            disableDefaultUI  : false,
            zoomControl       : true,
            mapTypeId         : google.maps.MapTypeId.ROADMAP,
            scrollwheel       : false,
            fullscreenControl : false
        });

        $.each(markers, function(index, marker){

            var markerLatLng = new google.maps.LatLng(marker.latitude, marker.longitude);

            // Create the Barrowford marker
            var mapMarker = new google.maps.Marker({
                map           : map,
                position      : markerLatLng,
                //animation     : google.maps.Animation.DROP,
                icon          : '/themes/intelligent/assets/graphics/misc/map-marker.png',
                opacity         : marker.id, // used to pass in ID of advert
            });

			bounds.extend(markerLatLng);

            // on click of property open property popup
            if(mapMarker.opacity && marker.url) {
                google.maps.event.addListener(mapMarker, 'click', function(){
                	window.location.href = marker.url;
                });
            }

            mapMarkers.push(mapMarker);
        });

        // cluster map results
        if (typeof(markerClusterer.MarkerClusterer) != 'undefined') {
            var markerCluster = new markerClusterer.MarkerClusterer(
                {
                    map: map,
                    markers: mapMarkers,
                    imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});

            // open property popup on click passing in all property IDs from this cluster
            google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {
                if (map.getZoom() >= 20) {
                    var selectedMarkers = cluster.getMarkers(),
                        advertIds = [];

                    $.each(selectedMarkers, function(key, selectedMarker) {
                        advertIds.push(selectedMarker.opacity);
                    });

                    oc.progressBar.show();

                    oc.ajax('propertyAdvertsPopout::onSearch', {
                        data: {advertIds: advertIds},
                        update: {'properties/popup': '.js-popup-property'},
                        success: function(data, textStatus, jqXHR) {
                            this.success(data, textStatus, jqXHR);

                            oc.progressBar.hide();

                            window.site.openInlinePopup('#popup-property')
                        }
                    });
                }
            });
        }

        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1    = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
            var extendPoint2    = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }

    	map.fitBounds(bounds);

        let latitude    = $('input[name="latitude"]').val(),
            longitude   = $('input[name="longitude"]').val(),
            distance    = $('select[name="distance"]').val(),
            radius      = distance/0.00062137; // Miles to meters

        if(latitude !== '' && longitude !== '') {

            if(distance > 0) {

                // Draw circle on map
                var circle = new google.maps.Circle({
                    strokeColor: '#262637',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#ebe9e5',
                    fillOpacity: 0.1,
                    map: map,
                    center: new google.maps.LatLng(latitude, longitude),
                    radius: radius
                });

                // Center map around circle
                bounds = new google.maps.LatLngBounds();
                bounds.extend(new google.maps.LatLng(circle.getBounds().getNorthEast().lat(), circle.getBounds().getNorthEast().lng()));
                bounds.extend(new google.maps.LatLng(circle.getBounds().getSouthWest().lat(), circle.getBounds().getSouthWest().lng()));
                map.fitBounds(bounds);

            } else {
                // Draw around the area searched for



            }
        }
	}

    if (typeof(streetviewCanvas) != 'undefined' && streetviewCanvas != null) {
        var marker = markers[0],
            svCoordinates = new google.maps.LatLng(marker.latitude, marker.longitude),
            svs = new google.maps.StreetViewService();


        svs.getPanorama({location: svCoordinates, radius: 50}, function(data, status) {
            if (status == 'OK') {
                sv = new google.maps.StreetViewPanorama(streetviewCanvas, {
                    position: svCoordinates,
                    pov: {
                        heading: parseFloat(marker.svHeading ? marker.svHeading : 90),
                        pitch: parseFloat(marker.svPitch ? marker.svPitch : 10)
                    }
                });
            } else {
                $('[href="#tab-streetview"]').parent('li').remove();
                streetviewCanvas.innerHTML = '<div class="alert alert-warning text-center">Unfortunately street view isn&apos;t available for this property</div>';
            }
        });

    }

	$(window).resize(function(){
        if (map) {
        	map.fitBounds(bounds);

        	if (markers.length == 1) {
	        	map.setZoom(16);
	        }
        }
    });
};
